import React, { memo, useState } from "react";
import { useSelector } from "react-redux";
import { BaseTemplate } from "../../components/templates";
import withResponseHandling from "../../hoc/withResponseHandling";
import MembrosList from "./MembrosList";
import MembroRegras from "./MembroRegras";

const EntidadeMembros = memo((props) => {
  const xDefaultEntidadeStored = useSelector((store) => store.entidade.current);
  const [seletedUser, setSeletecUser] = useState({});

  return (
    <BaseTemplate
      title="Membros"
      subtitle={xDefaultEntidadeStored.entidade}
      maxWidth="lg"
    >
      <MembrosList setSeletecUser={setSeletecUser} />
      <MembroRegras user={seletedUser} onClose={() => setSeletecUser({})} />
    </BaseTemplate>
  );
});

export default withResponseHandling(EntidadeMembros);
